module.exports = __webpack_public_path__ + "static/media/hard_dollars_3.8cfcee5a.png";